module.exports = __webpack_public_path__ + "images/maria-montessori-00683d0c7c290a18c73834eefa7aaf69.jpg";